// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"zl","imageWrapper":"zm","image":"zn","copyrightAndBrandLogo":"zo","brandLogo":"zp","copyright":"zq","rentalBadge":"zr"};